/* ============================================================
   androidTiktok.js — robot TikTok APP PHONE (Draft sahaja buat masa ini)
   ============================================================
   Keputusan user 4 Nov 2026 (PLAN_PHONE_TIKTOK_FB.md):
   - SEMUA jenis post = simpan DRAFT (bukan Post) — "buat semua draft dulu".
   - Jenis: video · gambar (carousel, ikut susunan gambar card) · text.
   - App TikTok phone TIADA schedule (diukur) → tiada kalendar untuk mod ini.
   Diukur pada Redmi 14C (720×1640, Android 14), TikTok `com.ss.android.ugc.trill`.

   Skrin TikTok boleh dibaca (kecuali feed Home — video main → dump gagal).
   Butang "+" dan tab Profile di bar bawah = KEDUDUKAN (nisbah skrin), lain-lain
   dicari ikut teks / content-desc / id.
   ⛔ "Your Story" (post TERUS ke Story) — robot TIDAK PERNAH menyentuhnya.
   ⛔ Butang "Post" — robot TIDAK menekannya (Draft sahaja).

   Bukti Draft: Profile → "Drafts: N" mesti naik +1 selepas larian.
   Pulang bentuk SAMA runRecipe (androidRunner.js) supaya pemanggil sedia ada
   (handleRunPhone / Test) membaca hasil dengan cara yang sama.
   ============================================================ */

import {
  delay, bacaSkrinSelamat, tunggu, tungguHilang, ketuk, cariKetuk, shell,
  dialogSistem, teksSelamat, taipTepat, keyboardNaik, gambarTerbaru,
} from './androidDumpKit';
import { buatPenyasar } from './androidAjar';

export const TIKTOK_PKG = 'com.ss.android.ugc.trill';

// Kedudukan bar bawah (nisbah) — diukur 4 Nov: "+" (360,1490) · Profile (650,1490) pada 720×1640.
const POS = { plus: [0.5, 0.909], profile: [0.903, 0.909], upload: [0.111, 0.89] };

const LANGKAH = {
  launch: { labelEn: 'Open TikTok', labelMs: 'Buka TikTok' },
  profile_start: { labelEn: 'Check drafts', labelMs: 'Semak draft' },
  open_create: { labelEn: 'Tap create (+)', labelMs: 'Tekan cipta (+)' },
  open_gallery: { labelEn: 'Open gallery', labelMs: 'Buka galeri' },
  pick_media: { labelEn: 'Select media', labelMs: 'Pilih media' },
  editor_next: { labelEn: 'Confirm edit', labelMs: 'Sahkan edit' },
  write_text: { labelEn: 'Write text', labelMs: 'Tulis text' },
  caption: { labelEn: 'Write caption', labelMs: 'Isi caption' },
  yellow_bag: { labelEn: 'Add yellow bag', labelMs: 'Pasang beg kuning' },
  ai_label: { labelEn: 'AI label', labelMs: 'AI label' },
  save_draft: { labelEn: 'Save draft', labelMs: 'Simpan draft' },
  verify_draft: { labelEn: 'Confirm draft saved', labelMs: 'Sahkan draft tersimpan' },
};

// Senarai langkah ikut jenis kandungan (untuk paparan progress). bag = pasang beg kuning (video).
export function tiktokSteps(content = 'video', { bag = false } = {}) {
  const ids = content === 'text'
    ? ['launch', 'profile_start', 'open_create', 'write_text', 'editor_next', 'ai_label', 'save_draft', 'verify_draft']
    : ['launch', 'profile_start', 'open_create', 'open_gallery', 'pick_media', 'editor_next', 'caption',
      ...(bag && content === 'video' ? ['yellow_bag'] : []), 'ai_label', 'save_draft', 'verify_draft'];
  return ids.map((id) => ({ id, ...LANGKAH[id] }));
}

/* Padan produk pilihan dengan card. Nama lalai di skrin "Rename product" = tajuk produk
   TikTok dipotong 30 aksara (diukur 4 Nov: "ROLLED OATS, CHIA SEEDS & MIX"). Card import
   TikTok memakai tajuk sama. Padan = (tanpa perkataan terakhir yang mungkin terpotong)
   awalan nama card, ATAU ≥80% perkataannya ada dalam nama card. */
const normal = (s) => String(s || '').toLowerCase().replace(/&amp;/g, '&').replace(/[^a-z0-9]+/g, ' ').trim();
export function samaNamaProduk(lalai, namaCard) {
  const a = normal(lalai).split(' ').filter(Boolean);
  const b = normal(namaCard);
  if (!a.length || !b) return false;
  const teras = a.length > 1 ? a.slice(0, -1) : a; // perkataan akhir mungkin terpotong
  if (b.startsWith(teras.join(' '))) return true;
  // ⛔ Perkataan pertama MESTI sama: marketplace ada tiruan hampir sama dari kedai lain
  // ("NEW ROLLED OATS, CHIA SEEDS…" lwn "ROLLED OATS, CHIA SEEDS…", diukur 4 Nov).
  const bw = b.split(' ');
  if (teras[0] !== bw[0]) return false;
  const set = new Set(bw);
  return teras.filter((w) => set.has(w)).length / teras.length >= 0.8;
}

const sz = (ctl) => [ctl?.info?.screenWidth || 720, ctl?.info?.screenHeight || 1640];
const ketukNisbah = async (ctl, [rx, ry], ms = 1500) => {
  const [w, h] = sz(ctl);
  await ctl.tap(Math.round(rx * w), Math.round(ry * h));
  await delay(ms);
};

// Skrin post (butiran): ada butang "Drafts" DAN "Post".
const diSkrinPost = (e, els) => e.text === 'Drafts' && els.some((x) => x.text === 'Post');
const kotakCaption = (els) => els.find((e) => e.id === 'h_n')
  || els.filter((e) => /EditText/.test(e.cls) && !/catchy title/i.test(e.text))
    .sort((a, b) => (b.b.y2 - b.b.y1) - (a.b.y2 - a.b.y1))[0];

async function bacaDraftCount(ctl) {
  // Profile dimuat bila nampak "Following"/"Followers"/"Likes" atau kiraan Drafts.
  const r = await tunggu(ctl, (e) => e.id === 'tv_draft' || /^(Following|Followers|Likes)$/i.test(e.text), 12000);
  if (!r) return null;
  let d = r.els.find((e) => e.id === 'tv_draft' || /^Drafts:\s*\d+/i.test(e.text));
  // Akaun ber-Shop: profile boleh terbuka di tab Showcase (beg) → kiraan Drafts hanya di tab
  // "Videos" (content-desc, diukur 4 Nov @heyrez.0).
  if (!d) {
    const tab = r.els.find((e) => e.desc === 'Videos' && e.clickable);
    if (tab) {
      await ketuk(ctl, tab, 2500);
      const r2 = await tunggu(ctl, (e) => e.id === 'tv_draft' || /^Drafts:\s*\d+/i.test(e.text), 4000);
      d = r2 ? r2.el : null;
    }
  }
  const m = d && String(d.text).match(/(\d+)/);
  return m ? Number(m[1]) : 0;
}

/* Pastikan masih di skrin post. Back untuk tutup keyboard kadang sampai SELEPAS keyboard
   tutup sendiri → TikTok kembali ke editor (diukur 4 Nov). Pulih: editor ada "Next" →
   tekan → skrin post semula (caption + tetapan kekal, diukur 4 Nov). */
async function pastikanSkrinPost(ctl) {
  if (await tunggu(ctl, diSkrinPost, 3000)) return true;
  for (let k = 0; k < 2; k++) {
    const nx = await tunggu(ctl, (e) => e.text === 'Next', 3000);
    if (!nx) break;
    await ketuk(ctl, nx.el, 1500);
    if (await tunggu(ctl, diSkrinPost, 12000)) return true;
  }
  return false;
}


// Caption TikTok: hashtag di hujung → tambah ruang supaya senarai cadangan hashtag
// tertutup (diukur 4 Nov: tanpa ruang, ketukan seterusnya memilih cadangan
// "#sesaatkaudatang" dan caption rosak).
function captionTaip(raw) {
  const c = teksSelamat(raw, 2000);
  return /#[^\s#]+$/.test(c) ? c + ' ' : c;
}


/* runTiktokPhone(controller, cfg, cb)
   cfg = { serial, params: { content:'video'|'image'|'text', caption, text, aiLabel(bool, lalai true),
                             videoDest, imageNames:[nama fail ikut susunan slide] } }
   cb  = { onStep({index,total,id,label,status,note}), onLog(msg,level) } */
export async function runTiktokPhone(controller, cfg = {}, cb = {}) {
  const ctl = controller;
  const p = cfg.params || {};
  const content = ['image', 'text'].includes(p.content) ? p.content : 'video';
  const aiLabel = p.aiLabel !== false;
  // Beg kuning: params.begKuning + productName (nama card = tajuk produk TikTok) + ctaText.
  const bag = !!(p.begKuning && content === 'video' && String(p.productName || '').trim());
  const cta = teksSelamat(p.ctaText || 'BELI KAT SINI', 30) || 'BELI KAT SINI';
  const steps = tiktokSteps(content, { bag });
  const total = steps.length;
  const onStep = typeof cb.onStep === 'function' ? cb.onStep : () => {};
  const log = (m, l = 'info') => cb.onLog?.(m, l);
  if (!ctl?.connected) return { status: 'failed', reason: 'not-connected' };
  if (!ctl.info) { try { await ctl.getDeviceInfo(); } catch { /* biar */ } }
  /* Ajar robot (4 Nov): butang penting dicari ikut tangga ajaran pelanggan → default →
     minta pelanggan tunjuk (bila cfg.ajar.mintaAjar ada — page Set up & test). Kunci
     'tt.*' = NAMA TETAP butang (dipakai dalam storan + ayat sokongan). */
  const { ketukSasar } = buatPenyasar({
    ctl, appId: 'tiktok', log,
    ajaran: cfg.ajar?.ajaran, mintaAjar: cfg.ajar?.mintaAjar, paksaGagal: cfg.ajar?.paksaGagal,
  });
  const S = (kunci, label, langkah, o) => ketukSasar(kunci, { label, langkah, ...o });

  let draftAwal = null;
  let begGagal = ''; // beg kuning gagal tetapi larian diteruskan (Draft tanpa beg)
  let capDiharap = ''; let capGagal = false; // semakan akhir caption sebelum Drafts
  let diPost = false;            // sudah sampai skrin post → jaring Draft boleh dipakai
  const belumSiap = [];

  const gagal = (id, reason) => ({ id, reason });
  const jalan = {
    launch: async () => {
      await shell(ctl, ['am', 'force-stop', TIKTOK_PKG]);
      await delay(700);
      await ctl.launchApp(TIKTOK_PKG);
      await delay(7000);
      const d = await dialogSistem(ctl);
      if (d) return gagal('launch', 'Ada popup kebenaran Android di phone — tekan sendiri di phone, kemudian Run semula.');
      const pkg = await ctl.getForegroundPackage();
      if (!String(pkg).includes(TIKTOK_PKG)) return gagal('launch', 'TikTok tak terbuka di phone (app di depan: ' + (pkg || '?') + ').');
      return null;
    },
    profile_start: async () => {
      // Popup boleh menutup bar bawah → cuba sekali tutup dengan Back dahulu.
      const diProfile = async () => (draftAwal = await bacaDraftCount(ctl)) != null;
      await ketukNisbah(ctl, POS.profile, 2500);
      if (await diProfile()) { log(`Draft sedia ada: ${draftAwal}`); return null; }
      await ctl.back(); await delay(1200);
      const r = await S('tt.profile_tab', 'Profile tab', 'Check drafts', { pos: POS.profile, sahkan: diProfile });
      if (r.ok) { log(`Draft sedia ada: ${draftAwal}`); return null; }
      return gagal('profile_start', 'Profile TikTok tak dapat dibuka (akaun belum login atau ada popup).');
    },
    open_create: async () => {
      const kamera = (e) => e.id === 'upload_hot_area' || e.text === 'PHOTO' || e.text === 'TEXT';
      const r = await S('tt.create_plus', 'Create (+) button', 'Tap create (+)', {
        pos: POS.plus, sahkan: async () => !!(await tunggu(ctl, kamera, 8000)),
      });
      if (r.ok) return null;
      if (await dialogSistem(ctl)) return gagal('open_create', 'Ada popup kebenaran Android (kamera/mikrofon) — benarkan sendiri di phone, kemudian Run semula.');
      return gagal('open_create', 'Skrin cipta TikTok tak terbuka.');
    },
    open_gallery: async () => {
      const r = await S('tt.upload', 'Upload (gallery) button', 'Open gallery', {
        pred: (e) => e.id === 'upload_hot_area', pos: POS.upload, ms: 4000,
        sahkan: async () => !!(await tunggu(ctl, (e) => e.desc === 'Photos' || e.desc === 'Videos', 10000)),
      });
      if (!r.ok) {
        if (await dialogSistem(ctl)) return gagal('open_gallery', 'Ada popup kebenaran galeri — benarkan sendiri di phone, kemudian Run semula.');
        return gagal('open_gallery', 'Galeri TikTok tak terbuka.');
      }
      return null;
    },
    pick_media: async () => {
      const tab = content === 'image' ? 'Photos' : 'Videos';
      if (!(await S(`tt.gallery_tab_${tab.toLowerCase()}`, `${tab} tab`, 'Select media', { pred: (e) => e.desc === tab && e.clickable, ms: 5000 })).ok) return gagal('pick_media', `Tab ${tab} tak dijumpai dalam galeri.`);
      await delay(800);
      // Mod pilih banyak: bulatan pilih muncul atas setiap petak. Tetapan ini diingat TikTok.
      let r = await tunggu(ctl, (e) => e.id === 'l3z', 2500);
      if (!r) {
        const sm = await S('tt.select_multiple', '"Select multiple" button', 'Select media', {
          pred: (e) => /^Select multiple$/i.test(e.text), ms: 4000,
          sahkan: async () => !!(await tunggu(ctl, (e) => e.id === 'l3z', 5000)),
        });
        if (!sm.ok) return gagal('pick_media', '"Select multiple" tak dijumpai.');
        r = await tunggu(ctl, (e) => e.id === 'l3z', 5000);
        if (!r) return gagal('pick_media', 'Bulatan pilih media tak muncul.');
      }
      const bulatan = r.els.filter((e) => e.id === 'l3z').sort((a, b) => (a.b.y1 - b.b.y1) || (a.b.x1 - b.b.x1));
      // Petak mana untuk setiap media (ikut susunan slide).
      let petak = [0];
      if (content === 'image') {
        const nama = (p.imageNames || []).filter(Boolean);
        if (!nama.length) return gagal('pick_media', 'Tiada gambar dihantar ke phone.');
        const terbaru = await gambarTerbaru(ctl, nama.length);
        petak = nama.map((n) => terbaru.indexOf(n));
        if (petak.some((i) => i < 0 || i >= nama.length)) return gagal('pick_media', 'Gambar card bukan gambar terbaru dalam galeri phone (ada gambar lain masuk serentak?). Run semula.');
      }
      if (petak.some((i) => !bulatan[i])) return gagal('pick_media', 'Petak media dalam galeri tak dijumpai.');
      for (const i of petak) { await ketuk(ctl, bulatan[i], 900); }
      const n = petak.length;
      // Semak bilangan bila teks "Next (N)" boleh dibaca; teks lain (bahasa lain) → tangga ajaran.
      const bil = await tunggu(ctl, (e) => /^Next \(\d+\)$/.test(e.text), 4000);
      if (bil && !new RegExp(`\\(${n}\\)$`).test(bil.el.text)) return gagal('pick_media', `Bilangan media dipilih tak sama (${n}).`);
      const nx = await S('tt.gallery_next', 'Next button (gallery)', 'Select media', {
        pred: (e) => new RegExp(`^Next \\(${n}\\)$`).test(e.text), ms: 5000,
        sahkan: async () => !!(await tunggu(ctl, (e) => e.id === 'tv_quick_publish' || e.text === 'Next', 12000)),
      });
      if (!nx.ok) return gagal('pick_media', 'Butang Next galeri tak dijumpai.');
      await delay(2000);
      return null;
    },
    write_text: async () => {
      if (!(await S('tt.text_mode', 'TEXT mode', 'Write text', {
        pred: (e) => e.text === 'TEXT', ms: 5000,
        sahkan: async () => !!(await tunggu(ctl, (e) => e.text === 'Try now' || e.id === 'hwm' || /EditText/.test(e.cls), 6000)),
      })).ok) return gagal('write_text', 'Mod TEXT tak dijumpai.');
      await cariKetuk(ctl, (e) => e.text === 'Try now' && e.clickable, 2500, 2500); // kali pertama sahaja
      const r = await tunggu(ctl, (e) => e.id === 'hwm' || /EditText/.test(e.cls), 6000);
      if (!r) return gagal('write_text', 'Kotak text tak dijumpai.');
      const teks = teksSelamat(p.text || p.caption, 1000);
      if (!teks) return gagal('write_text', 'Card tiada teks untuk post text.');
      const hasil = await taipTepat(ctl, teks, {
        ketukKotak: () => ketuk(ctl, r.el, 300),
        bacaKotak: async () => {
          const x = await tunggu(ctl, (e) => e.id === 'hwm' || /EditText/.test(e.cls), 3000);
          return x ? x.el.text : null;
        },
      }, log);
      if (!hasil.ok) return gagal('write_text', `Text tak masuk dengan tepat (${hasil.nota}).`);
      if (!(await S('tt.text_next', 'Next button (text)', 'Write text', {
        pred: (e) => e.text === 'Next' && e.clickable, ms: 4000,
        sahkan: async () => !!(await tunggu(ctl, (e) => e.id === 'tv_quick_publish' || e.text === 'Select a style', 10000)),
      })).ok) return gagal('write_text', 'Butang Next selepas text tak dijumpai.');
      await delay(2000);
      return null;
    },
    editor_next: async () => {
      // Editor: butang "Next" (bukan "Your Story" — post terus ke Story).
      const r = await S('tt.editor_next', 'Next button (editor)', 'Confirm edit', {
        pred: (e) => e.text === 'Next' && e.id !== 'tv_quick_publish', ms: 12000,
        sahkan: async () => !!(await tunggu(ctl, diSkrinPost, 20000)),
      });
      if (!r.ok) return gagal('editor_next', 'Skrin post TikTok tak terbuka.');
      diPost = true;
      return null;
    },
    caption: async () => {
      const cap = captionTaip(p.caption);
      if (!cap) { log('Caption kosong — dilangkau.', 'warn'); return null; }
      const r = await tunggu(ctl, (e, els) => e === kotakCaption(els), 6000);
      if (!r) return gagal('caption', 'Kotak caption tak dijumpai.');
      const bacaCap = async () => {
        const x = await bacaSkrinSelamat(ctl);
        const k = x && kotakCaption(x);
        return k ? k.text : null;
      };
      // ⚠️ Diukur 4 Nov: video tertentu → TikTok ISI caption sendiri beberapa saat SELEPAS skrin
      // post terbuka ("Jemput Follow dan save #doa…") dan menindih teks robot. Tunggu kotak STABIL
      // (dua bacaan sama) dahulu; hasil berbeza → cuba sekali lagi.
      await delay(2500);
      for (let k = 0, lama = await bacaCap(); k < 4; k++) {
        await delay(1200);
        const kini = await bacaCap();
        if (kini === lama) break;
        lama = kini;
      }
      const taipSekali = () => taipTepat(ctl, cap, { ketukKotak: () => ketuk(ctl, r.el, 300), bacaKotak: bacaCap }, log);
      let hasil = await taipSekali();
      if (hasil.ok) {
        await delay(2000); // isian lewat TikTok masih boleh tiba
        const akhir = await bacaCap();
        if (akhir != null && !(akhir.replace(/\s+/g, ' ').trim() === cap.replace(/\s+/g, ' ').trim())) hasil = { ok: false, nota: 'ditindih' };
      }
      if (!hasil.ok) { log(`Caption cuba sekali lagi (${hasil.nota}).`, 'warn'); hasil = await taipSekali(); }
      // Isian TikTok boleh tiba LEBIH LEWAT lagi → semakan akhir sejurus sebelum Drafts (save_draft).
      capDiharap = cap;
      if (!hasil.ok) {
        log('Caption belum tepat — akan disemak semula sebelum simpan Draft.', 'warn');
        if (await keyboardNaik(ctl)) { await ctl.back(); await delay(1000); }
        if (!(await pastikanSkrinPost(ctl))) return gagal('caption', 'Terkeluar dari skrin post selepas caption.');
        return null;
      }
      if (await keyboardNaik(ctl)) { await ctl.back(); await delay(1000); }
      if (!(await pastikanSkrinPost(ctl))) return gagal('caption', 'Terkeluar dari skrin post selepas caption.');
      return null;
    },
    /* Beg kuning (diukur 4 Nov, akaun TikTok Shop @heyrez.0):
       Add link → "Product" → skrin "Add product links" (skrin web — nama produk TIDAK boleh
       dibaca; hanya butang `button_add_product`) → "Search products" → hasil (showcase +
       marketplace) → Add → dialog "Add product to video?" (tak boleh dibaca; butang Add
       ~ (360,908)) → skrin "Rename product": kotak nama = tajuk produk (boleh dibaca) →
       SAHKAN dengan nama card; salah → Back, cuba calon seterusnya → taip CTA (≤30, satu-satu
       huruf) → `edit_anchor_add_button` → skrin post: cip `b41` = teks CTA (bukti beg).
       ⛔ Carian ID produk = "No products found" → carian ikut NAMA. */
    yellow_bag: async () => {
      const nama = String(p.productName || '').trim();
      const kunci = teksSelamat(nama, 200).split(' ').slice(0, 6).join(' ');
      if (!(await S('tt.add_link', 'Add link', 'Add yellow bag', {
        pred: (e) => e.desc === 'Add link' && e.clickable, ms: 5000,
        sahkan: async () => { await delay(1500); return !!(await tunggu(ctl, (e) => e.id === 'tv_anchor' || e.id === 'tv_panel_title', 5000)); },
      })).ok) return gagal('yellow_bag', '"Add link" tak dijumpai.');
      const prod = await tunggu(ctl, (e) => e.text === 'Product' && e.id === 'tv_anchor', 5000);
      if (!prod) {
        await cariKetuk(ctl, (e) => e.desc === 'Close' && e.clickable, 2000, 1500);
        return gagal('yellow_bag', 'Akaun TikTok ini tiada pilihan Product (bukan akaun TikTok Shop affiliate).');
      }
      // Sheet "Add link" masih bergerak → ketukan pertama boleh terlepas (diukur 4 Nov). Tunggu
      // stabil + ulang ketuk selagi "Product" masih kelihatan.
      let cari = null;
      for (let k = 0; k < 3 && !cari; k++) {
        await delay(900);
        const pr = await tunggu(ctl, (e) => e.text === 'Product' && e.id === 'tv_anchor', 2500);
        if (pr) await ketuk(ctl, pr.el, 5000);
        cari = await tunggu(ctl, (e) => e.text === 'Search products' && e.clickable, 8000);
      }
      if (!cari) return gagal('yellow_bag', 'Skrin pilih produk TikTok tak terbuka.');
      // "Search products" membuka SKRIN CARIAN BAHARU (kotak di atas). Taip hanya selepas kotak
      // itu wujud — menaip semasa peralihan = hilang senyap (diukur 4 Nov: carian tiada dalam sejarah).
      await ketuk(ctl, cari.el, 2500);
      const kotak = await tunggu(ctl, (e) => /EditText/.test(e.cls), 6000);
      if (!kotak) return gagal('yellow_bag', 'Kotak carian produk tak muncul.');
      const hc = await taipTepat(ctl, kunci, {
        perlahan: true,
        ketukKotak: () => ketuk(ctl, kotak.el, 800),
        bacaKotak: async () => { const x = await bacaSkrinSelamat(ctl); const k = x && x.find((e) => /EditText/.test(e.cls)); return k ? k.text : null; },
      }, log);
      if (!hc.ok) return gagal('yellow_bag', `Carian produk tak tertaip dengan tepat (${hc.teks || hc.nota}).`);
      await shell(ctl, ['input', 'keyevent', '66']); // Enter = cari
      await delay(6000);
      const senaraiAdd = async () => {
        const r = await tunggu(ctl, (e) => /button_add_product/.test(e.desc), 10000);
        return r ? r.els.filter((e) => /button_add_product/.test(e.desc)).sort((a, b) => a.b.y1 - b.b.y1) : [];
      };
      let calon = await senaraiAdd();
      if (!calon.length) return gagal('yellow_bag', `Produk "${kunci}" tak dijumpai dalam carian TikTok.`);
      // Dua rupa (diukur 4 Nov): dari senarai showcase → dialog → "Rename product" (butang
      // `edit_anchor_add_button`); dari HASIL CARIAN → terus "Add a product" (butang desc " Add").
      const butangAddBawah = (x) => (/edit_anchor_add_button/.test(x.desc + x.id) || /^\s*Add$/.test(x.desc)) && x.b.y1 > 1200;
      const skrinRename = (e, els) => /EditText/.test(e.cls) && els.some(butangAddBawah);
      for (let i = 0; i < Math.min(3, calon.length); i++) {
        if (i > 0) calon = await senaraiAdd();
        if (!calon[i]) break;
        await ketuk(ctl, calon[i], 2500);
        let rn = await tunggu(ctl, skrinRename, 2500);
        if (!rn) { await ketukNisbah(ctl, [0.5, 0.554], 4000); rn = await tunggu(ctl, skrinRename, 6000); } // dialog "Add product to video?" → Add
        if (!rn) return gagal('yellow_bag', 'Skrin "Rename product" tak muncul selepas Add.');
        const lalai = rn.el.text;
        if (!samaNamaProduk(lalai, nama)) {
          log(`Calon ${i + 1} bukan produk card ("${lalai}") — cuba seterusnya.`, 'warn');
          await ctl.back(); await delay(2500);
          continue;
        }
        const h = await taipTepat(ctl, cta, {
          perlahan: true,
          ketukKotak: () => ketuk(ctl, rn.el, 800),
          bacaKotak: async () => { const x = await bacaSkrinSelamat(ctl); const k = x && x.find((e) => /EditText/.test(e.cls)); return k ? k.text : null; },
        }, log);
        if (await keyboardNaik(ctl)) { await ctl.back(); await delay(1200); }
        if (!h.ok) log(`Teks CTA beg tidak tepat (${h.teks}).`, 'warn');
        const btn = await tunggu(ctl, butangAddBawah, 4000);
        if (!btn) return gagal('yellow_bag', 'Butang Add (Rename product) tak dijumpai.');
        await ketuk(ctl, btn.el, 5000);
        if (!(await pastikanSkrinPost(ctl))) return gagal('yellow_bag', 'Tak kembali ke skrin post selepas pasang beg.');
        const cip = await tunggu(ctl, (e) => e.id === 'b41' && e.text, 5000);
        if (!cip) return gagal('yellow_bag', 'Cip beg kuning tak kelihatan pada skrin post.');
        log(`Beg kuning dipasang: "${cip.el.text}" (produk "${lalai}").`, 'ok');
        return null;
      }
      // Tiada padanan → keluar dari skrin produk, balik ke skrin post.
      for (let k = 0; k < 3 && !(await tunggu(ctl, diSkrinPost, 1500)); k++) { await ctl.back(); await delay(2000); }
      return gagal('yellow_bag', `Produk card "${nama.slice(0, 40)}" tak dijumpai dalam 3 hasil carian teratas TikTok.`);
    },
    ai_label: async () => {
      let mo = await tunggu(ctl, (e) => e.desc === 'More options' && e.clickable, 3000);
      if (!mo) {
        const [w, h] = sz(ctl);
        await ctl.swipe(Math.round(w / 2), Math.round(h * 0.75), Math.round(w / 2), Math.round(h * 0.4), 400);
        await delay(1200);
        mo = await tunggu(ctl, (e) => e.desc === 'More options' && e.clickable, 4000);
      }
      const baris = (e) => e.clickable && /^AI-generated content/.test(e.desc);
      const bukaMo = await S('tt.more_options', 'More options', 'AI label', {
        pred: (e) => e.desc === 'More options' && e.clickable, ms: 1500,
        sahkan: async () => { await delay(1300); return !!(await tunggu(ctl, (e) => baris(e) || e.id === 'pv6' || /^Allow comments/.test(e.desc), 4000)); },
      });
      if (!bukaMo.ok) return gagal('ai_label', '"More options" tak dijumpai.');
      let ai = await tunggu(ctl, baris, 3000);
      if (!ai) {
        const [w, h] = sz(ctl);
        await ctl.swipe(Math.round(w / 2), Math.round(h * 0.85), Math.round(w / 2), Math.round(h * 0.5), 400);
        await delay(1200);
        ai = await tunggu(ctl, baris, 4000);
      }
      if (!ai) { await ctl.back(); await delay(1200); return gagal('ai_label', 'Suis AI-generated content tak dijumpai.'); }
      if (ai.el.checked !== aiLabel) {
        await ketuk(ctl, ai.el, 1800);
        await cariKetuk(ctl, (e) => e.text === 'Turn on' && e.clickable, 2500, 1500); // popup kali pertama
        ai = await tunggu(ctl, (e) => baris(e) && e.checked === aiLabel, 4000);
      }
      await ctl.back(); await delay(1200);
      if (!(await pastikanSkrinPost(ctl))) return gagal('ai_label', 'Terkeluar dari skrin post selepas AI label.');
      if (!ai) return gagal('ai_label', `AI label tak dapat di${aiLabel ? 'hidupkan' : 'matikan'}.`);
      log(`AI label ${aiLabel ? 'ON' : 'OFF'}.`);
      return null;
    },
    save_draft: async () => {
      if (!(await pastikanSkrinPost(ctl))) return gagal('save_draft', 'Skrin post tiada.');
      // Semakan akhir caption (isian lewat TikTok dari maklumat video boleh menindih bila-bila masa).
      if (capDiharap) {
        const sama = (t) => String(t || '').replace(/\s+/g, ' ').trim() === capDiharap.replace(/\s+/g, ' ').trim();
        const baca = async () => { const x = await bacaSkrinSelamat(ctl); const k = x && kotakCaption(x); return k ? k.text : null; };
        let kini = await baca();
        for (let k = 0; k < 2 && kini != null && !sama(kini); k++) {
          log(`Caption ditindih oleh TikTok ("${String(kini).slice(0, 40)}…") — taip semula.`, 'warn');
          const ks = await tunggu(ctl, (e, els) => e === kotakCaption(els), 4000);
          if (!ks) break;
          await taipTepat(ctl, capDiharap, { ketukKotak: () => ketuk(ctl, ks.el, 300), bacaKotak: baca }, log);
          if (await keyboardNaik(ctl)) { await ctl.back(); await delay(1000); }
          if (!(await pastikanSkrinPost(ctl))) return gagal('save_draft', 'Terkeluar dari skrin post semasa membetulkan caption.');
          await delay(2000);
          kini = await baca();
        }
        if (kini != null && !sama(kini)) { capGagal = true; log('Caption masih tidak tepat — Draft disimpan, caption perlu disemak.', 'err'); }
      }
      // Skrin post sentiasa boleh dibaca; selepas Drafts TikTok ke feed (video → tak boleh dibaca).
      const r = await S('tt.drafts', 'Drafts button', 'Save draft', {
        pred: diSkrinPost, ms: 5000,
        sahkan: () => tungguHilang(ctl, diSkrinPost, 20000, { gagalBacaKiraHilang: true }),
      });
      if (!r.ok) return gagal('save_draft', 'Masih di skrin post selepas tekan Drafts.');
      return null;
    },
    verify_draft: async () => {
      await delay(2500);
      for (let k = 0; k < 3; k++) {
        await ketukNisbah(ctl, POS.profile, 2500);
        const n = await bacaDraftCount(ctl);
        if (n != null && draftAwal != null && n >= draftAwal + 1) { log(`Draft disahkan (${draftAwal} → ${n}).`, 'ok'); return null; }
        await delay(2000);
      }
      return gagal('verify_draft', 'Draft tak dapat disahkan di Profile → Drafts. Semak phone sebelum Run semula.');
    },
  };

  for (let i = 0; i < total; i++) {
    const s = steps[i];
    onStep({ index: i, total, id: s.id, label: s.labelEn, status: 'running' });
    let err;
    try { err = await jalan[s.id](); } catch (e) { err = gagal(s.id, e?.message || String(e)); }
    if (!err) { onStep({ index: i, total, id: s.id, label: s.labelEn, status: 'pass' }); continue; }
    onStep({ index: i, total, id: s.id, label: s.labelEn, status: 'error', note: err.reason });
    log(`Gagal di "${s.labelEn}": ${err.reason}`, 'err');
    if (s.id === 'verify_draft') return { status: 'failed', failedAt: 'finish', reason: err.reason, draftSaved: false };
    // Drafts mungkin sudah tersimpan walau skrin tak dapat disahkan → semak kiraan dahulu.
    if (s.id === 'save_draft' && diPost && !(await jalan.verify_draft().catch(() => true))) {
      log('Draft disahkan melalui Profile walaupun skrin selepas Drafts tak dapat dibaca.', 'ok');
      return { status: 'draft_saved', finishedAs: 'draft' };
    }
    if (s.id === 'save_draft' || !diPost) return { status: 'failed', failedAt: s.id, reason: err.reason, draftSaved: false };
    // Jaring Draft: sudah di skrin post → simpan Draft walaupun isi belum lengkap.
    // Beg gagal di tengah skrin produk → Back sehingga skrin post (peraturan user: beg gagal →
    // DRAF), kemudian TERUSKAN langkah lain (AI label, Draft) — beg dilapor belum siap.
    if (s.id === 'yellow_bag') {
      for (let k = 0; k < 5 && !(await tunggu(ctl, diSkrinPost, 1500)); k++) {
        if (await tunggu(ctl, (e) => e.id === 'tv_quick_publish', 800)) break; // editor → pastikanSkrinPost tekan Next
        await ctl.back(); await delay(2000);
      }
      if (await pastikanSkrinPost(ctl)) { begGagal = err.reason; continue; }
    }
    // Isi yang belum disahkan: langkah gagal ini + langkah isi selepasnya yang tak sempat jalan.
    steps.slice(i).forEach((x) => {
      if (x.id === 'caption') belumSiap.push('caption');
      if (x.id === 'yellow_bag') belumSiap.push('beg kuning');
      if (x.id === 'ai_label') belumSiap.push('AI label');
    });
    const errD = await jalan.save_draft().catch((e) => gagal('save_draft', e?.message || e))
      || await jalan.verify_draft().catch((e) => gagal('verify_draft', e?.message || e));
    if (errD) return { status: 'failed', failedAt: s.id, reason: `${err.reason} · Draft juga gagal: ${errD.reason}`, draftSaved: false };
    if (begGagal && !belumSiap.includes('beg kuning')) belumSiap.unshift('beg kuning');
    return { status: 'failed', finishedAs: 'draft', failedAt: s.id, reason: err.reason, draftSaved: true, belumSiap };
  }
  // Semua lain siap, beg / caption sahaja gagal → Draft tak lengkap (dilapor jelas, bukan "siap").
  if (begGagal || capGagal) {
    const belum = [...(capGagal ? ['caption'] : []), ...(begGagal ? ['beg kuning'] : [])];
    return { status: 'failed', finishedAs: 'draft', failedAt: capGagal ? 'caption' : 'yellow_bag', reason: capGagal ? 'Caption ditindih oleh TikTok (maklumat video).' : begGagal, draftSaved: true, belumSiap: belum };
  }
  return { status: 'draft_saved', finishedAs: 'draft' };
}
